


















import Vue from 'vue'
import { mapActions } from 'vuex'
import { RootActionNames } from '@/store'
import moment from 'moment-timezone'
import { buildBarChartOptions, buildDataPointsByDay, fillDate } from '@/components/patient-stats/common/utils'
import { CHART_DATE_FORMAT } from '@/components/patient-stats/constants'
import { removeAbbr, USER_TIME_ZONE } from '@/utils/time'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    startTimestamp() {
      return this.patientWithStats.resultStartTimestamp
    },
    endTimestamp() {
      return this.patientWithStats.resultEndTimestamp
    },
    timezone() {
      return this.patientWithStats.timezone
    },
    awakeningsCountChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      if (
        !this.patientWithStats ||
        !this.patientWithStats.numberOfAwakenings ||
        !this.patientWithStats.numberOfAwakenings.length
      ) {
        return null
      }

      const { numberOfAwakenings, resultStartTimestamp, resultEndTimestamp } = this.patientWithStats
      const timezone = this.patientWithStats.timezone || USER_TIME_ZONE
      const numberOfAwakeningsMapByDay: { [key: string]: number } = buildDataPointsByDay(numberOfAwakenings, timezone)
      const xAxisLabels: string[] = [...fillDate(timezone, resultStartTimestamp, resultEndTimestamp)].map(timestamp =>
        String(timestamp)
      )
      const seriesXData: Array<[string, number]> = Object.entries(numberOfAwakeningsMapByDay)

      return buildBarChartOptions({
        baseColor: this.$vuetify.theme.themes.light.burgundy,
        lowValueColor: this.$vuetify.theme.themes.light.teal,
        threshold: 4,
        minYValue: 0.1,
        maxYValue: 10,
        seriesXData,
        xAxisLabels,
        tooltipFormatter: this.getFormatter(timezone, 'times'),
        timezone,
      })
    },
  },

  methods: {
    getFormatter(timezone, unit): (params: any) => string {
      return params => {
        // @ts-ignore
        const [timestamp, value] = params.data.value
        const dateText = moment(parseInt(timestamp, 10))
          .tz(timezone)
          .format(removeAbbr(timezone, CHART_DATE_FORMAT.DAY_ABBR))
        return `${dateText}\n${value} ${value <= 1 ? unit.slice(0, -1) : unit}`
      }
    },
  },
})
